import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PATHS } from "@/content/landing";
import Reveal from "./Reveal";

export default function DualPath() {
  return (
    <section className="landing-section dual-path" id="parcours">
      {PATHS.map((p, i) => (
        <Reveal key={p.key} delay={i * 0.08} className={`path-card path-${p.key}`}>
          <span className="eyebrow">{p.eyebrow}</span>
          <h2>{p.title}</h2>
          <ul>{p.points.map(pt => <li key={pt}><Check size={13} />{pt}</li>)}</ul>
          <Link to={p.cta.to} className={`button ${p.key === "player" ? "button-dark" : "button-outline"}`} data-testid={p.cta.testid}>{p.cta.label}<ArrowRight size={14} /></Link>
        </Reveal>
      ))}
    </section>
  );
}
